import { Pipe, PipeTransform } from '@angular/core';
import { TransitTaskStatusEnum } from '@zaoblako/shared/modules/cctv/enums/transit-task/transit-task-status.enum';

const transitTaskStatusNames: Record<TransitTaskStatusEnum, string> = {
  [TransitTaskStatusEnum.NEW]: 'Новая',
  [TransitTaskStatusEnum.IN_PROCESS]: 'Въезд',
  [TransitTaskStatusEnum.COMPLETED]: 'Выезд'
};

@Pipe({
  name: 'transitTaskStatusName',
  standalone: true
})
export class TransitTaskStatusNamePipe implements PipeTransform {
  public transform(status: TransitTaskStatusEnum): string {
    return transitTaskStatusNames[status] || '';
  }
}
